export default __webpack_public_path__ + "static/media/target-bg.7f285a67.png";